'use client';

import { useEffect, useState } from 'react';

export default function Preloader() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const onLoad = () => {
      setIsLoading(false);
    };

    // Wait for all resources (images, fonts, etc.)
    if (document.readyState === 'complete') {
      onLoad();
    } else {
      window.addEventListener('load', onLoad);
    }

    return () => {
      window.removeEventListener('load', onLoad);
    };
  }, []);

  if (!isLoading) return null;

  return <div id="preloader" />;
}
